import { URL } from "../env";
import { getIdToken, signOutUser } from "../contexts/AuthContext";

function redirectToErrorPage(reason, params = {}) {
  const searchParams = new URLSearchParams({ reason });
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      searchParams.set(key, String(value));
    }
  });

  const errorUrl = `/error?${searchParams.toString()}`;
  const currentUrl = `${window.location.pathname}${window.location.search}`;
  if (currentUrl !== errorUrl) {
    window.location.replace(errorUrl);
  }
}

function redirectToLogin() {
  if (window.location.pathname === "/login") {
    return;
  }

  const redirect = `${window.location.pathname}${window.location.search}`;
  const loginUrl = `/login?redirect=${encodeURIComponent(redirect)}`;
  window.location.replace(loginUrl);
}

export async function apiRequest(path, options = {}) {
  const { skipRedirectOn401 = false, ...fetchOptions } = options;
  const token = await getIdToken();
  const isFormData = fetchOptions.body instanceof FormData;
  const headers = {
    Authorization: `Bearer ${token}`,
    ...fetchOptions.headers,
  };
  if (!isFormData) {
    headers["Content-Type"] = "application/json";
  }
  let response;
  try {
    response = await fetch(`${URL}${path}`, {
      ...fetchOptions,
      headers,
    });
  } catch (error) {
    redirectToErrorPage("network-error");
    throw error;
  }
  if (response.status === 401) {
    signOutUser();
    if (!skipRedirectOn401) {
      redirectToLogin();
    }
    throw new Error("Unauthorized");
  }
  if (response.status >= 500) {
    redirectToErrorPage("server-error", { status: response.status });
  }
  return response;
}
